import React from "react";

export default function Loader() {
  return (
    <div className="loader">
      <div className="inner one"></div>
      <div className="inner two"></div>
      <div className="inner three"></div>

      <style>{`
        .loader {
          position: fixed;
          top: calc(50% - 32px);
          left: calc(50% - 32px);
          width: 64px;
          height: 64px;
          border-radius: 50%;
          perspective: 800px;
          z-index: 9999;
          background: transparent;
        }

        .inner {
          position: absolute;
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }

        /* Using your color #0d6efd */
        .inner.one {
          animation: rotate-one 1s linear infinite;
          border-bottom: 3px solid #0d6efd;
        }
        .inner.two {
          animation: rotate-two 1s linear infinite;
          border-right: 3px solid #0d6efd;
        }
        .inner.three {
          animation: rotate-three 1s linear infinite;
          border-top: 3px solid #0d6efd;
        }

        @keyframes rotate-one {
          0% { transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg); }
          100% { transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg); }
        }
        @keyframes rotate-two {
          0% { transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg); }
          100% { transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg); }
        }
        @keyframes rotate-three {
          0% { transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg); }
          100% { transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg); }
        }
      `}</style>
    </div>
  );
}
